import styled from "styled-components"
import Hr from "@irati/ui/src/Layout/Hr"

export default styled(Hr)`
  margin: 5px 0;
`
